import { Navigate } from "react-router-dom";
import { detectInitialLocale, homePath } from "@/lib/routes";

export function LocaleRedirect() {
  const locale = detectInitialLocale();
  return <Navigate to={homePath(locale)} replace />;
}
